import { Dialog, Loader } from '@pwskills/rachnaui';

type PaymentModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const LoadingModal = (props: PaymentModalProps) => {
  const { open, setOpen } = props;
  return (
    <Dialog
      open={open}
      closeModal={() => {
        setOpen(false);
      }}
      closeEnable={false}
      isOutSideClick={false}
      className="z-[99999] large:!w-[42%] !p-[32px] regular:!px-[56px] regular:!py-8 large:!px-[140px] large:!py-14  regular:!w-[60%] rounded-xl"
    >
      <div className="h-[304px] flex justify-center items-center">
        <Loader />
      </div>
    </Dialog>
  );
};
export default LoadingModal;
